<mapfre-header></mapfre-header>
<div class="container mapfre-content">
  <mapfre-card>
<div class="row text-center">
  <div class="col">
    <div class="header-icon full-icon">
      <svg-autopay-guest-svg></svg-autopay-guest-svg>
    </div>
    <h1 class="title-copy">{{ 'Your policy is in Autopay' | translate }}</h1> 
  <div class="sub-title-copy text-center lowercase margin-bottom mb32">
    {{ 'Please login to manage your payments'}}
  </div>
</div>
</div>
<div class="text-center margin-top mt32">
<div class="margin-bottom mb16">
  <mapfre-button 
    additionalClasses="basic primary large-btn"
    [routerLink]="['/login']"
  >
    {{ 'LOG INTO YOUR ACCOUNT' | translate }}
  </mapfre-button>
</div>
  <mapfre-button
    additionalClasses="link-button red-link small w-100 bcbrn button-border-red"
    [backIcon]="'../../../../../assets/img/icons/back-arrow-red.png'"
    [iconClasses]="'align-middle'"
    (click)="goBackAPage()"
    [showIconsCustom]="true">  
    {{ 'BACK' | translate }}
  </mapfre-button>
</div>
</mapfre-card>
</div>